module.exports = new __parcel__URL__("deployments-not-available.555f049b.svg").toString();